import { ChatItem, ToolCallStatus } from "features/assistant/definitions";
import { HistoryMessage } from "services/assistant/websocket";

const mapHistoryStatus = (status?: string): ToolCallStatus => {
  if (status === "completed") return "completed";
  if (status === "running") return "running";
  return "error";
};

/**
 * Converts MESSAGE_HISTORY_SNAPSHOT messages into a flat ChatItem[] array.
 * Text blocks become message items; tool_use blocks become independent tool_call items.
 * Consecutive text blocks within the same HistoryMessage are merged into one message item.
 */
export const convertHistoryMessages = (
  historyMessages: HistoryMessage[],
): ChatItem[] => {
  const items: ChatItem[] = [];

  for (const msg of historyMessages) {
    let pendingText: string | null = null;
    let pendingDisplayText: string | undefined;

    const flushText = () => {
      if (pendingText !== null) {
        items.push({
          type: "message",
          id: crypto.randomUUID(),
          role: msg.role,
          content: pendingText,
          displayContent: pendingDisplayText,
          isStreaming: false,
        });
        pendingText = null;
        pendingDisplayText = undefined;
      }
    };

    for (const block of msg.content) {
      if (block.type === "text") {
        if (pendingText !== null) {
          pendingText += `\n\n${block.text || ""}`;
        } else {
          pendingText = block.text || "";
          pendingDisplayText = block.display_text || undefined;
        }
      } else if (block.type === "tool_use") {
        flushText();
        items.push({
          type: "tool_call",
          id: crypto.randomUUID(),
          toolUseId: crypto.randomUUID(),
          toolName: block.tool_name || "unknown",
          status: mapHistoryStatus(block.status),
          description: block.description,
        });
      } else {
        console.warn("Unknown history content block type:", block.type);
      }
    }

    flushText();
  }

  return items;
};
